<div
  class="projects-configurator"
  [ngClass]="{ 'projects-configurator--custom-header': !!active?.snapshot.data?.customHeaderStyles }"
>
  @if (project()) {
    <app-project-creator-manage
      #configurator
      [headerStepOutOfTemplate]="true"
      [internalCreator]="true"
      [hideFooter]="true"
      [showHeaderLogo]="false"
      [projectValue]="project()"
      [config]="projectConfiguratorConfig"
    />
  }
</div>
